import classNames from 'classnames'
import LogoImage from '@/images/icons/logo.svg?react'
import MiniLogo from '@/images/icons/logo-short.svg?react'
import styles from './Logo.module.scss'
interface LogoProps {
  className?: string
  mini?: boolean
}

const Logo = ({className, mini}: LogoProps) => {
  return <div className={classNames(styles.logoContainer, className)}>
    {mini
      ? <MiniLogo className={classNames(styles.logo, styles.mini)} />
      : <LogoImage className={styles.logo}/>}
  </div>
}

export default Logo
